(ns hypnos.dme.bar.navigation
  "The DME main navigation bar."
  (:require [hypnos.dme.core.auth :as auth]
            [hypnos.dme.events]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- organization-nav-item
  "Organization drop down."
  [user organization]
  (let [user-orgs (:user/organizations user)]
    (if (< 1 (count user-orgs))
      [:div.navbar-item.has-divider.has-dropdown.is-hoverable
       [:a.navbar-link.is-arrowless
        [:div.is-user-name [:span (:organization/name organization)]]
        [:span.icon [:i.mdi.mdi-chevron-down]]]
       [:div.navbar-dropdown
        (for [org user-orgs]
          [:a.navbar-item
           {:key      (str "org-" (:organization/id org))
            :href     "#"
            :on-click (fn [_e]
                        (let [org-id (:organization/id org)]
                          (when (not= org-id (:organization/id organization))
                            (rf/dispatch [:dme/set-organization org-id]))))}
           [:span (:organization/name org)]])]]
      [:div.navbar-item.has-divider [:p (:organization/name organization)]])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bar

(defn bar
  "The navigation bar"
  []
  (let [auth         (rf/subscribe [:dme/auth])
        organization (rf/subscribe [:dme/organization])
        user         (rf/subscribe [:dme/user])
        panel        (rf/subscribe [:dme/active-panel])
        aside        (rf/subscribe [:dme/aside])
        user-name    (str (:user/first-name @user) " " (:user/last-name @user))]
    [:nav#navbar-main.navbar.is-fixed-top
     [:div.navbar-brand
      [:a.navbar-item.is-desktop-icon-only.is-hidden-touch.jb-aside-toggle
       {:title       (tr :ui.label/expand)
        :on-click    (fn [_] (rf/dispatch [:dme/toggle-aside]))
        :data-target "aside-main"}
       [:span.icon
        [:i.mdi.mdi-24px
         {:class (if (:expanded? @aside) "mdi-backburger" "mdi-forwardburger")}]]]
      [:a.navbar-item.is-hidden-desktop.jb-aside-mobile-toggle
       {:on-click (fn [_] (rf/dispatch [:dme/toggle-aside]))}
       [:span.icon
        [:i.mdi.mdi-24px
         {:class (if (:expanded? @aside) "mdi-backburger" "mdi-forwardburger")}]]]
      ;; main action
      (when (auth/authorized? @auth :create-new-consult)
        (let [disable? (not (contains? #{:dashboard-panel :patients-panel} (:name @panel)))]
          [:div.navbar-item
           [:a.button.is-success.is-small
            {:disabled disable?
             :href     (if disable? "" "/patient")}
            [:span (tr :ui.label/create-consult)]]]))
      (when (auth/authorized? @auth :create-new-consult)
        (let [disable? (not (contains? #{:dashboard-panel :patients-panel} (:name @panel)))]
          [:div.navbar-item
           [:a.button.is-success.is-small
            {:disabled disable?
             :href     (if disable? "" "/referral")}
            [:span (tr :ui.label/refer)]]]))]
     [:div.navbar-brand.is-right
      [:a.navbar-item.is-hidden-desktop.jb-aside-right-toggle
       [:span.icon
        [:i.mdi.mdi-bell.default]]]
      [:a.navbar-item.is-hidden-desktop.jb-navbar-menu-toggle
       {:data-target "navbar-menu"}
       [:span.icon
        [:i.mdi.mdi-dots-vertical]]]]
     [:div#navbar-menu.navbar-menu.fadeIn.animated.faster
      [:div.navbar-end
       [organization-nav-item @user @organization]
       [:div.navbar-item.has-divider [:p user-name]]
       [:a.navbar-item {:title (tr :ui.label/logout)}
        [:span
         {:on-click (fn [_] (rf/dispatch [:dme/logout]))}
         (tr :ui.label/logout)]]]]]))
